import Vue from 'vue'
import router from '@/router'

import '@/plugins/element.js'
import '@/plugins/moment.js'
import '@/plugins/qs.js'
import '@/plugins/clipboard.js'
import '@/plugins/drag.js'
import '@/common/utils/type.js'
import Fragment from 'vue-fragment';
// 导入全局样式表
import '@/assets/css/global.css'
require('@/static/icon/iconfont.js')
// import TreeTable from 'vue-table-with-tree-grid'
import { setStorage } from '@/common/utils/storage.js'
Vue.use(Fragment.Plugin);
// 拦截路由跳转
/*router.beforeEach((to, from, next) => {
        // 设置token
        setStorage('token', 'Token fb3036e741cc53f2025c97842924bff43a01dde')
        // document.title = to.meta.title + '运维管理系统';
    next()
})*/

Vue.config.productionTip = false
